'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LeftMenu$MenuItem(title, icon, links, test, always, feature, isNew) {
  this.Dc = null;
  this.D9 = null;
  this.Db = null;
  this.x9 = null;
  this.D8 = false;
  this.x8 = null;
  this.Da = false;
  this.Dc = title;
  this.D9 = icon;
  this.Db = links;
  this.x9 = test;
  this.D8 = always;
  this.x8 = feature;
  this.Da = isNew;
}
export { $c_Lpresto_LeftMenu$MenuItem as $c_Lpresto_LeftMenu$MenuItem };
$p = $c_Lpresto_LeftMenu$MenuItem.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LeftMenu$MenuItem;
/** @constructor */
function $h_Lpresto_LeftMenu$MenuItem() {
}
export { $h_Lpresto_LeftMenu$MenuItem as $h_Lpresto_LeftMenu$MenuItem };
$h_Lpresto_LeftMenu$MenuItem.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("MenuItem"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Dc));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.D9));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Db));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.x9));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.D8 ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.x8));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.Da ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 7);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_LeftMenu$MenuItem)) {
    if ((((this.D8 === x$0.D8) && (this.Da === x$0.Da)) && (this.Dc === x$0.Dc))) {
      var x = this.D9;
      var x$2 = x$0.D9;
      var $x_3 = (x === x$2);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Db;
      var x$4 = x$0.Db;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.x9;
      var x$6 = x$0.x9;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.x8;
      var x$8 = x$0.x8;
      return ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 7;
});
$p.s = (function() {
  return "MenuItem";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Dc;
      break;
    }
    case 1: {
      return this.D9;
      break;
    }
    case 2: {
      return this.Db;
      break;
    }
    case 3: {
      return this.x9;
      break;
    }
    case 4: {
      return this.D8;
      break;
    }
    case 5: {
      return this.x8;
      break;
    }
    case 6: {
      return this.Da;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_LeftMenu$MenuItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iD)));
}
export { $isArrayOf_Lpresto_LeftMenu$MenuItem as $isArrayOf_Lpresto_LeftMenu$MenuItem };
var $d_Lpresto_LeftMenu$MenuItem = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LeftMenu$MenuItem, "presto.LeftMenu$MenuItem", ({
  iD: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_LeftMenu$MenuItem as $d_Lpresto_LeftMenu$MenuItem };
//# sourceMappingURL=presto.-Left-Menu$-Menu-Item.js.map
